import { render, staticRenderFns } from "./item-subject.vue?vue&type=template&id=130cecab&scoped=true&"
import script from "./item-subject.vue?vue&type=script&lang=js&"
export * from "./item-subject.vue?vue&type=script&lang=js&"
import style0 from "./item-subject.vue?vue&type=style&index=0&id=130cecab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130cecab",
  null
  
)

export default component.exports